import { Row } from "react-bootstrap";
import "./css/ErrorMessage.css";
import { IErrorMessageProps } from "./Interfaces";
export default function ErrorMessage({ errors }: IErrorMessageProps) {
  return (
    <div className={"error-container"}>
      <Row>
        {errors.map((errorMessage, index) => (
          <label className="errorMessage" key={`error-${index}`}>{errorMessage}</label>
        ))}
      </Row>
    </div>
  );
}
